<div class="loading-modal">
    <loading-dots-component></loading-dots-component>
</div>